import { Menu } from 'lucide-react';
import { AvatarMenu } from './avatar-menu';
import { useMe } from '@/lib/auth';

type PortalTopbarProps = {
  onMenuClick: () => void;
};

/**
 * Client-facing topbar. Deliberately spare: which company you're in on the
 * left, account menu on the right. No timer, no admin search.
 */
export function PortalTopbar({ onMenuClick }: PortalTopbarProps) {
  const me = useMe();
  const clients = me.data?.portal_clients ?? [];
  const company =
    clients.length === 0
      ? null
      : clients.length === 1
        ? clients[0].name
        : `${clients[0].name} +${clients.length - 1}`;

  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b border-[var(--color-sidebar-border)] bg-[var(--color-sidebar)] text-[var(--color-sidebar-foreground)] px-3 sm:gap-3 sm:px-4">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Open navigation"
        className="inline-flex size-9 shrink-0 items-center justify-center rounded-md text-[var(--color-sidebar-muted-foreground)] hover:bg-[var(--color-sidebar-accent)] hover:text-[var(--color-sidebar-foreground)] md:hidden"
      >
        <Menu className="size-5" />
      </button>

      {company ? (
        <span className="min-w-0 truncate text-sm font-medium text-[var(--color-sidebar-foreground)]">
          {company}
        </span>
      ) : null}

      <div className="ml-auto flex items-center gap-2">
        {me.data ? <AvatarMenu name={me.data.name} avatarUrl={me.data.avatar_thumb_url} /> : null}
      </div>
    </header>
  );
}
